import React from 'react';

/**
 * EmptyCampaignIcon - Detailed crossed swords SVG for empty campaign state
 * Larger and more detailed than the sidebar version for better visibility
 */
const EmptyCampaignIcon = ({ size = 64 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 64 64" 
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'block' }}
  >
    {/* Sword 1: bottom-left to top-right */}
    {/* Blade */}
    <line x1="10" y1="54" x2="54" y2="10" strokeWidth="2.5" />
    {/* Tip detail */}
    <line x1="54" y1="10" x2="52" y2="8" strokeWidth="2" />
    {/* Guard (cross-piece) */}
    <line x1="50" y1="18" x2="46" y2="14" strokeWidth="3" />
    <line x1="54" y1="14" x2="50" y2="10" strokeWidth="3" />
    {/* Handle/grip */}
    <line x1="14" y1="50" x2="10" y2="54" strokeWidth="3" />
    {/* Pommel (end cap) */}
    <circle cx="8" cy="56" r="2.5" strokeWidth="2" />
    
    {/* Sword 2: bottom-right to top-left */}
    {/* Blade */}
    <line x1="54" y1="54" x2="10" y2="10" strokeWidth="2.5" />
    {/* Tip detail */}
    <line x1="10" y1="10" x2="12" y2="8" strokeWidth="2" />
    {/* Guard (cross-piece) */}
    <line x1="14" y1="18" x2="18" y2="14" strokeWidth="3" />
    <line x1="10" y1="14" x2="14" y2="10" strokeWidth="3" />
    {/* Handle/grip */}
    <line x1="50" y1="50" x2="54" y2="54" strokeWidth="3" />
    {/* Pommel (end cap) */}
    <circle cx="56" cy="56" r="2.5" strokeWidth="2" />
  </svg>
);

export default EmptyCampaignIcon;
